import { configureStore } from '@reduxjs/toolkit';
import { reducer as appReducer } from '#admin/reducer/app.ts';

export const store = configureStore({
  reducer: {
    app: appReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
